var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVuesaxOutlineCode2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "{props.color}",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.67 17.67c-.77-.39-1.43-.97-1.91-1.69-.4-.6-.4-1.37 0-1.97a4.91 4.91 0 0 1 1.91-1.68c.37-.19.82-.03 1.01.34.19.37.04.82-.34 1.01-.54.27-1 .68-1.33 1.18a.29.29 0 0 0 0 .31c.33.5.79.91 1.33 1.18.37.19.52.64.34 1.01-.14.24-.41.39-.68.39-.11 0-.23-.03-.33-.08zM14.54 17.34a.745.745 0 0 1 .34-1.01c.54-.27 1-.68 1.33-1.18a.29.29 0 0 0 0-.31c-.33-.5-.79-.91-1.33-1.18a.763.763 0 0 1-.34-1.01c.19-.37.64-.52 1.01-.34.77.39 1.43.97 1.91 1.69.4.6.4 1.37 0 1.97a4.91 4.91 0 0 1-1.91 1.68.66.66 0 0 1-.34.1c-.28 0-.54-.15-.67-.41z",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9 22.75c-5.43 0-7.75-2.32-7.75-7.75V9c0-5.43 2.32-7.75 7.75-7.75h6c5.43 0 7.75 2.32 7.75 7.75v6c0 5.43-2.32 7.75-7.75 7.75H9zM2.75 9v6c0 4.61 1.64 6.25 6.25 6.25h6c4.61 0 6.25-1.64 6.25-6.25V9c0-4.61-1.64-6.25-6.25-6.25H9C4.39 2.75 2.75 4.39 2.75 9z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.48 8.01c0-.41.33-.75.75-.75l19.22-.01a.749.749 0 1 1 0 1.5l-19.22.01c-.41 0-.75-.34-.75-.75z",
    fillRule: "nonzero"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVuesaxOutlineCode2);
export default __webpack_public_path__ + "static/media/vuesax-outline-code_2.c5fc7586d65d46a753e47ef26493d179.svg";
export { ForwardRef as ReactComponent };